import React, {useCallback, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {
  IconButton,
  Stack,
  Chat1Icon,
  SupportCenterIcon,
  Button,
  Divider,
  PencilEditNoteIcon
} from '@customink/pigment-react';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';

import {useNavigate} from 'react-router-dom';
import {metrics} from '~/vendor/metrics';
import {getCurrentDesignName} from '../../selectors/DesignSelectors';

import './CiHeaderDesignName.scss';

export const CiHeaderDesignName = () => {
  const navigate = useNavigate();
  const designName = useSelector(getCurrentDesignName);
  const handleNavigateToHelp = useCallback(() => {
    navigate('/help');
  }, []);
  const handleNavigateToSave = useCallback(() => {
    metrics.fireEvent('lab ways to order', 'save');
    navigate('/next/saveForm');
  }, []);

  useEffect(() => {
    window.setChatElements?.();
  }, []);

  return (
    <Stack
      justifyContent="space-between"
      direction="row"
      alignItems="center"
      spacing={2}>
      <Stack direction="row" alignItems="center">
        <Divider orientation="vertical" flexItem sx={{mx: '20px'}} />
        <Stack spacing={1.5} direction="row" alignItems="center">
          <Button
            variant="link"
            sx={{
              cursor: 'pointer',
              color: '#00000091',
              ':hover': {
                backgroundColor: designTokens.color.gray.hover.original.value
              },
              '&.Mui-disabled': {
                color: designTokens.color.gray.slateDark.value
              }
            }}
            disabled={designName}
            size="medium"
            onClick={handleNavigateToSave}
            endIcon={!designName && <PencilEditNoteIcon />}>
            {designName || 'Untitled Design'}
          </Button>
          <Button
            size="small"
            variant="secondary"
            onClick={handleNavigateToSave}>
            Save | Share
          </Button>
        </Stack>
      </Stack>
      <Stack direction="row" alignItems="center" justifyItems="center">
        <IconButton
          onClick={handleNavigateToHelp}
          className="ndx-save-menu-help-icon"
          sx={{
            width: '40px',
            height: '40px',
            display: {md: 'flex', lg: 'none'}
          }}>
          <SupportCenterIcon
            htmlColor={designTokens.color.gray.slateDefault.value}
            fontSize="inherit"
            sx={{width: '24px', height: '24px'}}
          />
        </IconButton>
        <IconButton
          id="LP_"
          className="ndx-save-menu-help-icon"
          sx={{
            width: '40px',
            height: '40px',
            display: {md: 'flex', lg: 'none'}
          }}>
          <Chat1Icon
            htmlColor={designTokens.color.gray.slateDefault.value}
            fontSize="inherit"
            sx={{width: '24px', height: '24px'}}
          />
        </IconButton>
        <Stack
          sx={{display: {md: 'none', lg: 'flex'}}}
          direction="row"
          spacing={0.5}
          gap={2}
          alignItems="center">
          <customer-contact />
          <customer-chat />
        </Stack>
        <Divider orientation="vertical" flexItem sx={{mx: '16px'}} />
      </Stack>
    </Stack>
  );
};
